import { Mappable, Mapped } from '../../rest/decorators/mapped'

@Mapped({
  job_id: { property: 'jobID' },
  parts_cost: { property: 'partsCost' },
  parts_used: { property: 'partsUsed' },
  hours_sold: { property: 'hoursSold' },
  hours_taken: { property: 'hoursTaken' },
})
export class JobPartsAndLabour extends Mappable {
  jobID!: number
  required!: number
  allocated!: number
  fulfilled!: number
  available!: number
  partsCost!: number
  partsUsed!: number
  hoursSold!: number
  hoursTaken!: number

  static create<Data>(attrs: Data) {
    return new JobPartsAndLabour().map(attrs)
  }
}
